/**
 * Mock配置文件
 **/
// 首先引入Mock
const Mock = require('mockjs');

// 设置拦截ajax请求的相应时间
Mock.setup({
    timeout: '200-600'
});

Mock.mock("/api/login", (req, res) => {
    {
        return Mock.mock({
            name: "admin",
            password: "123456",
            token: "20191129592"
        });
    }
});

Mock.mock("/api/yglx", (req, res) => {
    {
        return Mock.mock(
            {
                chartYglx: [
                    { name: "正式员工", value: 800 },
                    { name: "外来劳务", value: 100 },
                ],
                chartXbfb: [
                    { name: "男", symbol: "image://img/man.png", value: 500 },
                    { name: "女", symbol: "image://img/woman.png", value: 400 },
                ],
                chartNlgc: [
                    { name: "19-35岁", value: 500 },
                    { name: "36-50岁", value: 300 },
                    { name: "50-60岁", value: 100 },
                ],
                chartXlfb: [
                    { name: "高中及以下", value: 50 },
                    { name: "专科", value: 200 },
                    { name: "本科", value: 300 },
                    { name: "研究生", value: 80 },
                    { name: "博士及以上", value: 10 },
                ],
                chartTxryqs: [
                    { name: "1年", value: 5 },
                    { name: "2年", value: 10 },
                    { name: "3年", value: 20 },
                    { name: "4年", value: 40 },
                    { name: "5年", value: 50 },
                ],
                chartZjfb: [
                    { name: "2000以下", value: 100 },
                    { name: "2000-4000", value: 200 },
                    { name: "4000-6000", value: 200 },
                    { name: "6000-8000", value: 150 },
                    { name: "8000-10000", value: 50 },
                    { name: "1000+", value: 50 },
                ],
                chartSyqk: [
                    { name: "出租", value: 100 },
                    { name: "自用", value: 200 },
                    { name: "闲置", value: 200 },
                ],
                chartDwqk: [
                    { name: "单位1", value: 100 },
                    { name: "单位2", value: 200 },
                    { name: "单位3", value: 300 },
                    { name: "单位4", value: 250 },
                    { name: "单位5", value: 180 },
                    { name: "单位6", value: 230 },
                ],
                chartSbflqk: [
                    { name: "种类1", value: 100 },
                    { name: "种类2", value: 200 },
                    { name: "种类3", value: 300 },
                    { name: "种类4", value: 250 },
                    { name: "种类5", value: 180 },
                    { name: "种类6", value: 230 },
                ],
                chartWxlb: [
                    { name: "小修", value: 100 },
                    { name: "中修", value: 200 },
                    { name: "大修", value: 300 },
                    { name: "综合维修", value: 250 },
                    { name: "翻修", value: 180 },
                ],
                chartAjflqk: [
                    { name: "已处理", value: 300 },
                    { name: "未处理", value: 80 },
                    { name: "处理中", value: 100 },
                ],
                chartZzjg: {
                    "name": "公\n司\n领\n导",
                    "children": [
                        { "name": "工\n程\n部", },
                        { "name": "信\n息\n技\n术\n部", },
                        { "name": "人\n力\n资\n源\n部", },
                        { name: "西\n长\n安\n街\n房\n管\n子\n公\n司" },
                        { name: "金\n融\n街\n房\n管\n子\n公\n司" },
                        { name: "新\n接\n口\n房\n管\n子\n公\n司" },
                        { name: "德\n胜\n房\n管\n子\n公\n司" },
                        { name: "什\n刹\n海\n房\n管\n子\n公\n司" },
                        { name: "展\n览\n路\n房\n管\n子\n公\n司" },
                        { name: "月\n坛\n房\n管\n子\n公\n司" },
                        { name: "物\n业\n管\n理\n子\n公\n司" },
                        { name: "供\n暖\n管\n理\n子\n公\n司" },
                        { name: "职\n工\n学\n校\n" },
                        { name: "房\n地\n产\n测\n绘\n子\n公\n司" },
                    ]
                },
                chartGsdys: [
                    { name: "工程部",value:100 },
                    { name: "信息技术部",value:80 },
                    { name: "人力资源部",value:70 },
                    { name: "西长安街房管子公司",value:99 },
                    { name: "金融街房管子公司",value:120 },
                    { name: "新接口房管子公司",value:102 },
                    { name: "德胜房管子公司",value:109 },
                    { name: "什刹海房管子公司",value:36 },
                    { name: "展览路房管子公司",value:48 },
                    { name: "月坛房管子公司",value:67 },
                    { name: "物业管理子公司",value:89 },
                    { name: "供暖管理子公司",value:34 },
                    { name: "职工学校",value:78 },
                    { name: "房地产测绘子公司",value:100 },
                ]

            }
        );
    }
});
